import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay } from '@fortawesome/free-solid-svg-icons'

const ComparisonTable = () => {
  const gridCells = [
    // Row 1 - Header Row
    {
      id: 1,
      content: <img alt="" src="https://assets.learntube.ai/files/personalise/Group%2023642.webp" className='w-auto h-5'/>,
      bgClass: "",
      textClass: "",
      borderClass: "border-r border-b border-[#406AFF]/15"
    },
    {
      id: 2,
      content: "Online Courses",
      bgClass: "",
      textClass: "text-white text-[12px] font-medium",
      borderClass: "border-r border-b border-[#406AFF]/15"
    },
    {
      id: 3,
      content: <img alt="" src="https://assets.learntube.ai/files/personalise/image%2011.webp" className='w-5 h-5'/>,
      bgClass: "",
      textClass: "",
      borderClass: "border-b border-[#406AFF]/15"
    },
    // Row 2
    {
      id: 4,
      content: "Scattered videos",
      bgClass: "",
      textClass: "text-[#83BEFF] text-[12px] font-normal",
      borderClass: "border-r border-b border-[#406AFF]/15"
    },
    {
      id: 5,
      content: "Generic syllabus",
      bgClass: "",
      textClass: "text-[#83BEFF] text-[12px] font-normal",
      borderClass: "border-r border-b border-[#406AFF]/15"
    },
    {
      id: 6,
      content: "Personalised path",
      bgClass: "",
      textClass: "text-[#83BEFF] text-[12px] font-normal",
      borderClass: "border-b border-[#406AFF]/15"
    },
    // Row 3
    {
      id: 7,
      content: "No clear learning direction",
      bgClass: "",
      textClass: "text-[#83BEFF] text-[12px] font-normal",
      borderClass: "border-r border-b border-[#406AFF]/15"
    },
    {
      id: 8,
      content: "Same path for all",
      bgClass: "",
      textClass: "text-[#83BEFF] text-[12px] font-normal",
      borderClass: "border-r border-b border-[#406AFF]/15"
    },
    {
      id: 9,
      content: "Built around your goal and level",
      bgClass: "",
      textClass: "text-[#83BEFF] text-[12px] font-normal",
      borderClass: "border-b border-[#406AFF]/15"
    },
    // Row 4
    {
      id: 10,
      content: "Endless searching",
      bgClass: "",
      textClass: "text-[#83BEFF] text-[12px] font-normal",
      borderClass: "border-r border-b border-[#406AFF]/15"
    },
    {
      id: 11,
      content: "Limited personalisation",
      bgClass: "",
      textClass: "text-[#83BEFF] text-[12px] font-normal",
      borderClass: "border-r border-b border-[#406AFF]/15"
    },
    {
      id: 12,
      content: "Start learning directly",
      bgClass: "",
      textClass: "text-[#83BEFF] text-[12px] font-normal",
      borderClass: "border-b border-[#406AFF]/15"
    },
    // Row 5
    {
      id: 13,
      content: "Mixed content",
      bgClass: "",
      textClass: "text-[#83BEFF] text-[12px] font-normal",
      borderClass: "border-r border-[#406AFF]/15"
    },
    {
      id: 14,
      content: "Often outdated, static",
      bgClass: "",
      textClass: "text-[#83BEFF] text-[12px] font-normal",
        borderClass: "border-r border-[#406AFF]/15"
    },
    {
      id: 15,
      content: "Updated from current trends",
      bgClass: "",
      textClass: "text-[#83BEFF] text-[12px] font-normal",
      borderClass: "border-b border-[#406AFF]/15"
    }
  ]

  return (
    <div className='w-full flex flex-col items-center justify-center'>
      <h2 className="w-full text-[24px] font-bold text-left mb-4">Why LearnTube Is better</h2>
      <div className="w-full rounded-[24px] p-0 relative overflow-hidden bg-[#406AFF]/15" style={{
  backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(106,124,187,0.2) 100%),
  rgba(64, 106, 255, 0.15)
  `
}}>
        {/* Comparison Grid */}
        
          <div className="grid grid-cols-3 grid-rows-5  rounded-t-[16px] rounded-x-[16px] overflow-hidden">
            {gridCells.map((cell) => (
              <div 
                key={cell.id}
                className={`${cell.bgClass} py-2 px-2 min-h-[80px] flex items-center justify-center ${cell.borderClass} `}
              >
                {typeof cell.content === 'string' ? (
                  <p className={`${cell.textClass} text-center leading-[20px]`}>
                    {cell.content}
                  </p>
                ) : (
                  cell.content
                )}
              </div>
            ))}
          </div>

          {/* Bottom Highlight */}
          <div className=" rounded-b-[16px] py-2 text-center " style={{
  background: "linear-gradient(to right, rgba(64, 106, 255, 0.15) 0%, #406AFF 100%)"
}}>
            <p className="text-white italic font-medium text-white text-[12px] flex items-center justify-center gap-1">
              <span className="">⚡</span>
              Saves you hours of figuring out what to learn next
            </p>
          </div>

          
      </div>
    </div>
  )
}

export default ComparisonTable